import Axios from "@/plugins/Axios";
import Disciplina from "@/Models/Disciplina";
import store from "@/store";

export class DisciplinasService {
  async atualizarDisciplina(disciplina) {
    const response = await Axios().put(`disciplinas/${disciplina.id}`, disciplina);

    return response.data;
  }

  async criarDisciplina(disciplina) {
    const response = await Axios().post("disciplinas", disciplina);

    return response.data;
  }

  async deletarDisciplina(disciplina) {
    const response = await Axios().delete(`disciplinas/${disciplina.id}`);

    return response.data;
  }

  async listarAreasDeConhecimento() {
    const response = await Axios().get("disciplinas/area-conhecimento");

    return response.data;
  }

  async listarDisciplinas(gestao_id) {
    const response = await Axios().get(`disciplinas/listar/${gestao_id}`);

    return response.data.map((disciplina) => new Disciplina(disciplina));
  }

  async listarDisciplinasAEE() {
    const response = await Axios().get("disciplinas/educacao-inclusiva");

    const disciplinas = response.data.map((disciplina) => new Disciplina(disciplina));

    return disciplinas;
  }

  async listarDisciplinasPorTurma(turmaId) {
    if (!turmaId) throw new Error("Class ID is required");

    const response = await Axios().get(`disciplinas/turma/${turmaId}`);

    return response.data.map((disciplina) => new Disciplina(disciplina));
  }

  async recuperarDisciplina(disciplina) {
    return this.atualizarDisciplina({ ...disciplina, deleted_at: null });
  }

  async syncAll() {
    const response = await Axios().get("disciplinas");

    const disciplinas = response.data.map((disciplina) => new Disciplina(disciplina));

    return disciplinas;
  }

  async syncAllPaginated(pageNumber, query) {
    const response = await Axios().get(`disciplinas/paginate?page=${pageNumber}&query=${query}`);

    return response.data;
  }
}

export default new DisciplinasService();
